import Tracking from "@/model/Tracking";

const axios = require('axios');
const instance = axios.create({
  baseURL: 'https://g11jbxr01k.execute-api.us-east-1.amazonaws.com/live/ustrackingservice/',
  headers: {
    'content-type': 'application/json',
    'x-api-key': 'OrXxHpntdY8ijxAM11Hkc1QGEeqarRJB3P6frMQm',
    'accept': 'application/json',
  },
  data: {}
});

export default {
  data() {
    return {
      capsuleid: process.env.CAPSULEID,
      initTrackingUrl: 'initiatetrackerlog',
      eventTrackingUrl: 'publisheventlogtracker',
      finishTrackingUrl: 'finishtrackerlog',
    }
  },
  methods: {
    productTracking: function (page, product) {
      let event;
      let productReference;
      let productId;
      let productType;

      switch (page) {
        case 'home-design':
          productId = product.cpidstring;
          productReference = product.designproductname + ' ' + product.productname;
          event = 'View Home Design on page';
          productType = 'Home Design';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'elevation':
          productId = product.productid;
          productReference = product.productname;
          event = 'Select Elevation';
          productType = 'Elevation';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'hnl-package':
          productId = product.cpidstring;
          productReference = product.productname;
          event = 'View Package on page';
          productType = 'Package';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'brochure':
          productId = product.cpidstring;
          productReference = product.productname;
          event = 'Downloaded Brochure on page';
          productType = 'Brochure';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'documents-library':
          productId = product.cpidstring;
          productReference = product.productname;
          event = 'View Documents Library on Page';
          productType = product.producttype;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'download':
          productId = product.productId;
          productReference = JSON.stringify({
            DocumentType: product.type,
            DocumentSubType: product.subType,
            DocumentShortDescription: product.productName + ' Package PDF',
            DocumentFilename: product.productName + '.pdf',
            BuilderName: product.builderName,
          });
          event = product.event;
          productType = product.producttype;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'contact':
          productId = product.productid;
          productReference = product.contactid;
          event = 'Submitted Contact on Page';
          productType = 'Contact';
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'lot-click':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.productName,
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'handl-click':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Builder: product.builderName,
            Plan: product.productName,
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'home-click':
          productId = product.productId;
          productReference = JSON.stringify({
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.productName,
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'poi-click':
          productReference = JSON.stringify({
            Name: product.productName,
            Category: product.category,
            Featured: product.isFeatured,
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'enquiry-submit':
          productId = product.productId;
          productReference = JSON.stringify({
            FirstName: product.firstName,
            LastName: product.lastName,
            Mobile: product.mobile,
            Email: product.email,
            productId: product.shortListedProducts,
            productCount: product.productCount,
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'create-package':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.planProductName,
            Facade: product.productName,
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        case 'create-package':
          productId = product.productId;
          productReference = JSON.stringify({
            EstateName: product.estateProductName,
            StageName: product.stageProductName,
            LotName: product.lotProductName,
            Range: product.rangeProductName,
            Design: product.designProductName,
            Plan: product.planProductName,
            Facade: product.productName,
          });
          event = product.event;
          productType = product.productType;
          this.checkSession(event, productReference, productId, productType);
          break;
        default:
          break;
      }
    },

    checkSession: function (event, productreference, productid, producttype) {
      if (sessionStorage.getItem('trackerid')) {
        this.eventTracking(event, productreference, productid, producttype);
      } else {
        this.initiateTracking(event, productreference, productid, producttype);
      }
    },

    initiateTracking: function (event, reference, productId, productType) {
      const trackingItems = Tracking;
      return FingerprintJS.load().then((fp) => {
        fp.get().then(result => {
          trackingItems.fingerprint = result.visitorId;
          trackingItems.request_type = 'initiate_tracker';
          trackingItems.capsuleid = this.capsuleid;
          trackingItems.referrer = this.getReferrer();
          trackingItems.trackersource = this.getSource();
          trackingItems.trackeragent = this.getUserAgent();
          trackingItems.trackermessage = this.setTrackerMessage('Initiated tracker');

          this.postTracking(this.initTrackingUrl, trackingItems).then(res => {
            if (res && res.data) {
              let response = JSON.parse(res.data);
              if (response.trackerid) {
                sessionStorage.setItem('trackerid', response.trackerid);
                this.eventTracking(event, reference, productId, productType);
              }
            }
          })
        })
      })
    },

    eventTracking: function (event, reference, productId, productType) {
      let eventItems = {
        request_type: 'initiate_tracker_event',
        trackerid: this.getTrackerId(),
        productreference: this.getReference(reference),
        capsuleid: this.capsuleid,
        productid: this.getProductId(productId),
        producttype: this.getProductType(productType),
        eventname: this.setTrackerMessage(event),
      }
      this.postTracking(this.eventTrackingUrl, eventItems).then((res) => {
        console.log(res);
        return res;
      });
    },

    stopTracking() {
      const trackerid = this.getTrackerId();
      this.http.get(this.finishTrackingUrl + '?request_type="finish_tracker"&trackerid=' + trackerid).subscribe();
      sessionStorage.removeItem('trackerid');
    },

    getClientId() {
      if (!isNullOrUndefined(this.trackingApiParams.getClientTokens()[0])) {
        return this.trackingApiParams.getClientTokens()[0].clientId;
      } else {
        return this.trackingApiParams.getClientId();
      }
    },

    getCurrentTime() {
      const now = new Date();
      return new Date(now).toISOString();
    },

    getReferrer() {
      if (document.referrer !== '') {
        return document.referrer;
      } else {
        return document.baseURI
      }
    },

    getIp() {
      // No free IP tracking API available
      return '';
    },

    getProductId(productId) {
      if (productId) {
        return productId;
      }
      return '';
    },

    getProductType(productType) {
      if (productType) {
        return productType;
      }
      return '';
    },

    getUserAgent() {
      return navigator.userAgent;
    },

    getSource() {
      return window.location.href;
    },

    getReference(reference) {
      if (reference) {
        return reference;
      }
      return '';
    },

    setTrackerMessage: function (event) {
      let message = '';
      if (event) {
        message = event + ' ' + window.location.href;
      } else {
        message = 'Viewed page on ' + window.location.href;
      }
      return message;
    },

    getTrackerId: function () {
      return sessionStorage.getItem('trackerid');
    },


    postTracking(url, data) {
      return instance.post(url, data);
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Tracking.js